import React from "react";

const MagreachIcon = ({ width = 32, height = 32, ...props }) => (
  <img
    src="/influ8-icon.png"
    alt="INFLU8"
    width={width}
    height={height}
    style={{ objectFit: "contain", display: "block", borderRadius: 8 }}
    {...props}
  />
);

export default MagreachIcon;
